module.exports = __webpack_public_path__ + "static/media/ic_no_movement.42dec05b.png";